module.exports = __webpack_public_path__ + "assets/img/guangpuyi.8ce2beb4.jpg";